<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    hide-price-assessments-tab
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  MANGANESE,
  MARKET,
  SUBSCRIPTION_FORECASTS_MANGANESE,
} from '~/constants/services/constants'
import manganeseData from '~/constants/data-reports/manganese'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(MANGANESE)
const productData = ref(manganeseData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_MANGANESE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${MANGANESE.name} Data and Reports`,
})
useHead(seo)
</script>
